// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var AvatarSrcUrl = require("../../../utils/AvatarSrcUrl.bs.js");
var AgentInfo__Jsx3 = require("../../../uikit/reason/atoms/AgentInfo/AgentInfo__Jsx3.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var TerminatedAgentIconOverlay = require("../../common/Agent/TerminatedAgentIconOverlay.bs.js");
var BuyerPageMatchAnonymousAgent_anonymousForSalePropertyAgent_graphql = require("../../../__generated__/BuyerPageMatchAnonymousAgent_anonymousForSalePropertyAgent_graphql.bs.js");

var convertFragment = BuyerPageMatchAnonymousAgent_anonymousForSalePropertyAgent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, BuyerPageMatchAnonymousAgent_anonymousForSalePropertyAgent_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(BuyerPageMatchAnonymousAgent_anonymousForSalePropertyAgent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, BuyerPageMatchAnonymousAgent_anonymousForSalePropertyAgent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(BuyerPageMatchAnonymousAgent_anonymousForSalePropertyAgent_graphql.node, convertFragment, fRef);
}

var Fragment_membershipStatusV5_decode = BuyerPageMatchAnonymousAgent_anonymousForSalePropertyAgent_graphql.Utils.membershipStatusV5_decode;

var Fragment_membershipStatusV5_fromString = BuyerPageMatchAnonymousAgent_anonymousForSalePropertyAgent_graphql.Utils.membershipStatusV5_fromString;

var Fragment = {
  membershipStatusV5_decode: Fragment_membershipStatusV5_decode,
  membershipStatusV5_fromString: Fragment_membershipStatusV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function BuyerPageMatchAnonymousAgent(props) {
  var __size = props.size;
  var size = __size !== undefined ? __size : "xSmall";
  var match = use(props.agent);
  var tmp = match.membershipStatus;
  if ((tmp === "ACTIVE" || tmp === "TERMINATED") && tmp !== "ACTIVE") {
    return JsxRuntime.jsx(TerminatedAgentIconOverlay.make, {
                size: size,
                children: JsxRuntime.jsx(AgentInfo__Jsx3.make, {
                      avatar: AvatarSrcUrl.place_holder,
                      size: size,
                      name: "The agent chose to hide their name",
                      brokerage: "NO LONGER ON TAN",
                      wrapName: (function (name) {
                          return JsxRuntime.jsx("div", {
                                      children: name,
                                      className: "font-medium"
                                    });
                        })
                    })
              });
  }
  return JsxRuntime.jsx(AgentInfo__Jsx3.make, {
              avatar: AvatarSrcUrl.place_holder,
              size: size,
              name: "The agent chose to hide their name",
              wrapName: (function (name) {
                  return JsxRuntime.jsx("div", {
                              children: name,
                              className: "font-medium"
                            });
                })
            });
}

var make = BuyerPageMatchAnonymousAgent;

exports.Fragment = Fragment;
exports.make = make;
/* AvatarSrcUrl Not a pure module */
